import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { DEFAULT_STATSIG_EXPERIMENT_CONFIG, STATSIG_DEFAULT_LAYER } from '../constants';
export var getStatsigExperimentConfig = function getStatsigExperimentConfig(onErrorFn) {
  var isRequestDrivenExperimentationEnabled = FeatureGates.checkGate('request_driven_experimentation_enabled');
  if (!isRequestDrivenExperimentationEnabled) {
    return;
  }
  var response = _objectSpread({}, DEFAULT_STATSIG_EXPERIMENT_CONFIG);
  try {
    var layer = FeatureGates.getLayer(STATSIG_DEFAULT_LAYER);
    for (var _i = 0, _Object$entries = Object.entries(response); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      response[key] = layer.get(key, value);
    }
  } catch (error) {
    onErrorFn === null || onErrorFn === void 0 || onErrorFn(error);
  }
  return response;
};